


















































import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api';
import axios from 'axios';

import { PropType } from 'vue';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { extendProductsForBox, getProductTypesParentCategory, getTagColor, getTopicsParentCategory } from '~/utils/solepro/products';
import type { ProductForProductPageType } from '~/utils/types/solepro/Product';
import ProductBox from '~/components/solepro/ProductBox.vue';
import { BaseCategory } from '~/utils/types/ProductPage';
import { Pagination, Navigation } from 'swiper'
import { productUpSellLinkTrack, productUpSellNavTrack } from '~/helpers/trackings/24orepro/products';
import { FEMININE_CATEGORIES } from "~/utils/constants/product";
import { getAxiosConfigs } from '~/utils/solepro/functions';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { useConfig } from '~/composables';

SwiperCore.use([Pagination, Navigation])


export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    components: {
        ProductBox,
        Swiper,
        SwiperSlide
    },
    setup(props) {
        const product = props.product;
        const categoryStore = useCategoryStore();
        const { app } = useContext();
        const { config } = useConfig();
        const products = ref([]);
        const productType = ref<BaseCategory>();
        const productTopic = ref<BaseCategory>();
        useFetch(async () => {
            await categoryStore.load();
            const allcategories = categoryStore.rawCategories?.items[0].children;
            let variables;
            const productTopicsUids = getTopicsParentCategory(allcategories).children.map(el => el.uid);
                productTopic.value = product.categories.find(el => productTopicsUids.includes(el.uid)) as BaseCategory;
            if (product.upSell?.length > 0) {
                variables = { skus: product.upSell.map(el => el.sku) };
            } else if(productTopic.value){ 
                variables = { variables: { filter: { category_uid: { eq: productTopic.value.uid } } } }
            } else {
                const productTypeUids = getProductTypesParentCategory(allcategories).children.map(el => el.uid);
                productType.value = product.categories.find(el => productTypeUids.includes(el.uid)) as BaseCategory;
                variables = { variables: { filter: { category_uid: { eq: productType.value.uid } } } }
            }
            const { data } = await axios.post('/sole-api/product/pro/getProductBaseDataForBox', variables, {...getAxiosConfigs(app, config)});
            products.value = extendProductsForBox(allcategories, data.filter(el => el.sku != product.sku))
        })

        const swiperProps = {
            slidesPerView: "auto",
            spaceBetween: 12,
            modules: [Navigation, Pagination],
            slideClass: 'slide',
            pagination: {
                el: '.section-up-sell .pagination',
                type: 'progressbar',
                progressbarFillClass: 'bg-black w-full block h-full'
            },
            navigation: {
                prevEl: '.section-up-sell .navigation .prev-btn',
                nextEl: '.section-up-sell .navigation .next-btn',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        }

        const trackUpSellLink = (val, callback) => productUpSellLinkTrack(val, callback);
        const trackProductUpSellNav = (val) => productUpSellNavTrack(product, val); 

        const isFeminine = productType.value && FEMININE_CATEGORIES.includes(productType.value.name.toLowerCase())

        return {
            products,
            productType,
            productTopic,
            swiperProps,
            trackProductUpSellNav,
            trackUpSellLink,
            getTagColor,
            isFeminine
        }
    },
    methods: {
        calculateHeights(swiper) {
            const tallest = swiper.slides.reduce((tallest: Element, slide: Element) => {
                return slide.getBoundingClientRect().height > tallest.getBoundingClientRect().height ? slide : tallest;
            });
            const h = tallest.offsetHeight + 'px';
            swiper.slides.forEach(el => el.style.height = h)
            
            //document.querySelectorAll('.slide').forEach(slide=>slide.style.height = h+'px')
        },
        afterInit(swiper) {
             /** UGLY, VERY UGLY Try to check why the resize / swiper don't work as espected */
             const interval = setInterval(()=>{
                const slides = swiper.$el[0].querySelectorAll('.slide');
                if(slides.length>1){
                    clearInterval(interval);
                    setTimeout(()=>{
                        swiper.update();
                console.log('updated');
                this.calculateHeights(swiper)
                console.log(swiper.slides.length)
                    },1000)
                }
            },300)
            setTimeout(() => {
                clearInterval(interval)
            }, 10000)
        }
    }
})
